module.exports = __webpack_public_path__ + "media/customizations/valenciasky/back-c3b9885220664e7979773cc3c80207ad.jpg";